import { useTranslation } from "react-i18next";
import {
  GridRowContextMenuTypes,
  TGridRowContextMenu,
} from "components/Grid/types";
import { useURLTools } from "utils/URLtools";

/**
 * Right-click → "view details" / "open in new tab" for any grid whose rows
 * map to a detail page.
 *
 * `getDetailsPath` maps a row to its detail route; return `undefined` for rows
 * that have no detail page (a missing id, an aggregate row) and both menu items
 * become no-ops for that row.
 */
export function useGridDetailsContextMenu(
  getDetailsPath: (row: any) => string | undefined
): TGridRowContextMenu {
  const { t } = useTranslation();
  const { navigateWithQueryParams } = useURLTools();

  return {
    width: 210,
    items: [
      {
        text: t("viewDetails"),
        icon: "detailslayout",
        type: GridRowContextMenuTypes.openDetails,
      },
      {
        text: t("openInNewTab"),
        icon: "share",
        type: GridRowContextMenuTypes.openInNewTab,
      },
    ],
    onItemClick: (action, data) => {
      const path = getDetailsPath(data);
      if (!path) return;
      navigateWithQueryParams(path, [], {
        openInNewTab: action === GridRowContextMenuTypes.openInNewTab,
      });
    },
  };
}

export default useGridDetailsContextMenu;
